import { defineStore } from 'pinia';
import actions from './actions.js';

function initState() {
    return {
        historys: [],
        source: '',
    };
}

export default (storeName) => defineStore(storeName, {
    
    state: initState,
    actions
});
